

































































































































































































































































































































































import {
  defineComponent,
  useFetch,
  useRoute,
  computed,
  watch,
  ref,
  onMounted,
  useContext,
  ComputedRef,
  useMeta,
} from '@nuxtjs/composition-api'
import debounce from 'lodash.debounce'
import { useAuth } from '~/composables/useAuth'
import { useContent } from '~/composables/useContent'
import { BreadcrumbItem, useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useBreakpoint } from '~/composables/ui/useBreakpoint'
import { useProductDetail } from '~/composables/product/useProductDetail'
import { ProductEvents, useProduct } from '~/composables/product/useProduct'
import { useElementSize } from '~/composables/ui/useElementSize'
import { Modals, useModal } from '~/composables/ui/useModal'
import { useEvents } from '~/composables/framework/useEvents'
import { Anchor, AnchorHash, SocialKeys, SocialLink } from '~/types/common'
import { Product } from '~/types/product'
import { ContentPart, ContentMap } from '~/types/content'
import { useCart } from '~/composables/useCart'
import {
  SchemaScript,
  useBreadcrumbsSchemaScript,
  useProductSchemaScript,
} from '~/composables/useSchemaScript'
import { htmlToText } from '~/lib/utilities'

export default defineComponent({
  name: 'PagesProductDetail',

  setup() {
    const { i18n, $config } = useContext()
    const { authed } = useAuth()
    const { emit } = useEvents()
    const { setPageMeta, article, ensureContent, content } = useContent()
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const route = useRoute()
    const {
      loading: productLoading,
      product,
      specifications,
      connections,
      reviews,
      rating,
      sizeVariants,
      colorVariants,
      variantVariants,
      connectionsLoading,
      reviewsTotal,
      reviewsLoading,

      getProduct,
      getConnections,
      getReviews,
      addViewedProduct,
    } = useProductDetail()
    const { productQuantity } = useCart()
    const { breadcrumbsSchemaScript, setBreadcrumbsSchemaScript } =
      useBreadcrumbsSchemaScript()
    const { productSchemaScript, setProductSchemaScript } =
      useProductSchemaScript()

    const variantProduct = ref<Product | null>(null)

    const selectedProduct = computed(
      () => variantProduct.value ?? product.value ?? ({} as Product)
    )
    const quantity = ref(1)


    const contentMap = computed(
      () => (content.value?.[ContentPart.ContentMap] as ContentMap[]) ?? []
    )

    const cartQuantity = computed(() => {
      return selectedProduct.value?.id
        ? productQuantity(selectedProduct.value.id)
        : 0
    })

    const { isOrderable, availability, maxQuantityInc } = useProduct(
      selectedProduct as ComputedRef<Product>,
      cartQuantity
    )

    const inputIsInStock = computed(
      () => quantity.value <= maxQuantityInc.value
    )

    const productUrl = computed(() => route.value.params.slug)

    // webNodeId from category PLP clicked
    const currentWebNodeId = computed(() => {
      const webNodeId = Number(route.value?.query?.webNodeId)
      return webNodeId || undefined
    })
    // brandUrl from brand PLP clicked
    const currentBrandUrl = computed(() => route.value?.query?.brandUrl ?? '')

    useFetch(async () => {
      await ensureContent()
      await getProduct(productUrl.value, currentWebNodeId.value)
      if (!product.value || !article.value) return

      setPageMeta({
        type: 'product',
        title: article.value.title || product.value.name,
        description:
          product.value.description && htmlToText(product.value.description),
        img: article.value.images?.[0]?.src || product.value.img,
      })
      finalBreadcrumbs()
      setBreadcrumbsSchemaScript(breadcrumbs.value!)
      setProductSchemaScript(product.value as Product)
    })
    const addToCartText = computed(() => article.value?.unavailable?'Dit product is tijdelijk niet leverbaar':'Voeg toe aan winkelmand')
    const proUnavailable = computed(() => article.value?.unavailable)
    console.log(proUnavailable,addToCartText,"proUnavailable")
    const finalBreadcrumbs = () => {
      if (!product.value) return

      const webNode = product.value.webNode
      const breadcrumbAncestors: BreadcrumbItem[] = []

      if (currentBrandUrl.value && product.value.brand) {
        // from brand PLP
        breadcrumbAncestors.push(
          {
            to: { name: 'brand' },
            label: i18n.t('brand.title') as string,
          },
          {
            label: product.value.brand.name,
            to: {
              name: 'brand-lister-all',
              params: { pathMatch: currentBrandUrl.value as string },
            },
          }
        )
      } else if (webNode) {
        const finalWebNodes = [...(webNode.ancestors ?? []), webNode]
        if (currentWebNodeId.value) {
          // from category PLP
          const matchedIndex = finalWebNodes.findIndex(
            (webNode) => webNode.id === currentWebNodeId.value
          )
          if (matchedIndex !== -1) {
            finalWebNodes.splice(matchedIndex + 1)
          }
        }
        breadcrumbAncestors.push(
          ...finalWebNodes.map((webNode) => ({
            to: {
              name: 'product-lister-all',
              params: { pathMatch: webNode.url as string },
            },
            label: webNode.name,
          }))
        )
      }

      setBreadcrumbs([
        ...breadcrumbAncestors,
        {
          label: article?.value?.title || product?.value?.name,
        },
      ])
    }

    // Add viewed products
    if (process.client) {
      const productLoadedNAuthed = computed(() => {
        return product.value && authed.value
      })

      watch(productLoadedNAuthed, (value) => {
        if (!value) return
        addViewedProduct()
      })

      // Emit ViewDetails event
      if (product.value) {
        emit(ProductEvents.ViewDetails, {
          product: product.value,
        })
      }
      watch(product, (value) => {
        if (!value) return

        emit(ProductEvents.ViewDetails, {
          product: value,
        })

        Promise.all([getConnections(), getReviews()])
      })
    }

    // review
    // const rating = computed(() => {
    //   return product.value?.rating ?? 0
    // })

    /* --- scroll --- */
    const { isMobile } = useBreakpoint()

    const scrolledToMenu = ref(false)
    const headerHeight = ref(0)

    const headElement = computed(() => {
      if (!process.client) return null
      return document.querySelector('#app-header') as HTMLElement
    })

    const getHeaderHeight = () => {
      headerHeight.value = headElement.value?.offsetHeight ?? 131
    }

    const setScrolledToFilter = () => {
      if (process.client) {
        const top =
          (
            document.querySelector('#product-detail-menu') as HTMLElement
          )?.getBoundingClientRect().top ?? 0

        getHeaderHeight()

        scrolledToMenu.value = top <= headerHeight.value
      }
    }

    const sectionStyle = computed(() => {
      // 52 = 40 + 12 (navigation fixed height + reserved space)
      const navigationOffsetTop = headerHeight.value + 52
      return {
        paddingTop: `${navigationOffsetTop}px`,
        marginTop: `-${navigationOffsetTop}px`,
        pointerEvents: 'none',
      }
    })

    const onVariantProductSelected = (product: Product) => {
      variantProduct.value = product
    }

    watch(
      isMobile,
      (val) => {
        if (!process.client) return
        if (val) {
          scrolledToMenu.value = false
          window.removeEventListener('scroll', setScrolledToFilter)
        } else {
          window.addEventListener('scroll', setScrolledToFilter)
        }
      },
      {
        immediate: true,
      }
    )

    onMounted(() => {
      if (headElement.value) {
        useElementSize(headElement.value, debounce(getHeaderHeight, 150))
      }
    })

    /* --- anchors --- */
    const anchors = computed(() => {
      if (!product.value) return []

      const result: Anchor[] = []
      if (product.value.description) {
        result.push({
          title: `${i18n.t('product.text.description')}`,
          hash: AnchorHash.Description,
        })
      }
      if (product.value.ingredients) {
        result.push({
          title: `${i18n.t('product.text.ingredients')}`,
          hash: AnchorHash.Ingredients,
        })
      }
      if (specifications.value.length) {
        result.push({
          title: `${i18n.t('product.text.specifications')}`,
          hash: AnchorHash.Specifications,
        })
      }
      result.push({
        title: `${i18n.t('product.text.reviews')}`,
        hash: AnchorHash.Reviews,
      })
      if (Object.keys(connections).length) {
        result.push({
          title: `${i18n.t('product.text.relatedProducts')}`,
          hash: AnchorHash.Connections,
        })
      }
      return result
    })

    /* --- social links --- */
    const socialLinks = computed<SocialLink[]>(() => {
      if (!process.client) return []
      const url = window.location.href
      return [
        {
          key: SocialKeys.Facebook,
          value: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
          name: `${i18n.t('common.text.share', {
            name: 'Facebook',
          })}`,
        },
        {
          key: SocialKeys.Mail,
          value: `mailto:?subject=${i18n.t(
            'text.mailto.subject'
          )}&body=${i18n.t('text.mailto.body', {
            name: i18n.t('common.text.product'),
          })}!!! ${url}`,
        },
      ]
    })

    /* --- modal --- */
    const { open: openModal } = useModal()

    const showStockModal = () => {
      openModal(Modals.Stock, {
        product: selectedProduct.value,
      })
    }

    useMeta(() => {
      const scriptArr: SchemaScript[] = []
      if (breadcrumbsSchemaScript.value) {
        scriptArr.push(breadcrumbsSchemaScript.value)
      }
      if (productSchemaScript.value) {
        scriptArr.push(productSchemaScript.value)
      }

      return scriptArr.length
        ? {
            script: scriptArr,
          }
        : {}
    })

    useMeta(() => {
      return product.value
        ? {
            meta: [
              {
                property: 'product:availability',
                content: 'in stock', // product.value.inStock ? 'in stock' : 'out of stock',
              },
              {
                property: 'product:brand',
                content: product.value.brand?.name ?? '',
              },
              {
                property: 'product:category',
                content: product.value.webNode?.name ?? '',
              },
              {
                property: 'product:condition',
                content: 'new',
              },
              {
                property: 'product:gtin',
                content: product.value.scanCode ?? '',
              },
              {
                property: 'product:ean',
                content: product.value.scanCode ?? '',
              },
              {
                property: 'product:product_link',
                content: `${$config.DOMAIN}${route.value.path}`,
              },
              {
                property: 'product:retailer_category',
                content:
                  product.value.activeWebNodes?.[
                    product.value.activeWebNodes.length - 1
                  ]?.name ?? '',
              },
              {
                property: 'product:price:amount',
                content: product.value.priceInclTax.toString() ?? '',
              },
              {
                property: 'product:price:currency',
                content: 'EUR',
              },
              {
                property: 'product:size',
                content: product.value.size ?? '0',
              },
              {
                property: 'product:weight:value',
                content: '0',
              },
              {
                property: 'product:weight:units',
                content: 'kg',
              },
            ],
          }
        : {}
    })

    return {
      quantity,
      authed,
      article,
      productLoading,
      connectionsLoading,
      product,
      isOrderable,
      availability,
      maxQuantityInc,
      inputIsInStock,
      socialLinks,
      anchors,
      AnchorHash,
      specifications,
      productUrl,
      connections,
      reviews,
      reviewsLoading,
      colorVariants,
      sizeVariants,
      variantVariants,
      selectedProduct,
      addToCartText,
      proUnavailable,
      contentMap,

      scrolledToMenu,
      headerHeight,

      sectionStyle,
      rating,
      reviewsTotal,

      showStockModal,
      onVariantProductSelected,
      isMobile
    }
  },

  head: {},
})
